export default "__VITE_ASSET__BE82Z4fe__"